// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reservation-page[data-v-05456970] .filter-reservation-status-marker{border-radius:50%;width:20px;height:20px}.reservation-page[data-v-05456970] .ag-cell-wrapper{font-size:13px}.reservation-page[data-v-05456970] .filter-by-status-dropdown-item .dropdown-item{display:flex !important}", ""]);
// Exports
module.exports = exports;
